import React, { Component } from "react";

import MorphImg from "../../assets/images/ministries/Morph.jpg";
import GemsImg from "../../assets/images/ministries/GEMS.jpg";
import CadetsImg from "../../assets/images/ministries/Cadets.jpg";

class YouthMinistry extends Component {
	render() {
		return (
			<section>
				<header id="page-title">
					<div className="container">
						<h1>Youth Ministry</h1>
					</div>
				</header>
				<section className="container">
					<p className="lead">
						<strong>Morph</strong>
					</p>

					<p>
						<img className="morph-img " src={MorphImg} style={{ float: "right" }} alt="" />
						Morph is a youth group for people in year 8-12. It's a great place to learn about Jesus for the first time,
						or to grow your faith in Him.
						<br />
						<br />
						We spend time learning from the Bible, playing games and growing our friendships. Our year includes social
						nights, Q&A nights (on a range of topics), a weekend camp and Bible study nights.
						<br />
						<br />
						We would love to have you join us at Morph - there's always room for more! Please get in contact with us.
						<br />
						<br />
						Morph Details:
						<ul>
							<li>When: Sunday, 6:30-8:30pm (during private school term times)</li>
							<li>Where: CRCK, 17 Denison Street, Kingston</li>
							<li>Coordinator: Graham Sayer</li>
							<li>
								Contact: <a href="mailto:morph@kingstoncrc.org.au">morph@kingstoncrc.org.au</a>
							</li>
						</ul>
					</p>

					<br />
					<br />
					<p className="lead">
						<strong>G.E.M.S. & Cadets</strong>
					</p>
					<br />
					<img className="noFloatRightMobile" src={GemsImg} style={{ float: "right" }} alt="" />
					<p>
						CRCK has two single-sex youth clubs for young people from school grades 5 to 7, G.E.M.S. (for girls) and
						Cadets (for boys). <br />
						<br />
						Each week we study the Bible, pray, learn crafts and skills, and play lots of games. Each year both GEMS and
						Cadets goes on its own, weekend-long camp.
						<br />
						<br />
					</p>

					<p>
						G.E.M.S. Details:
						<ul>
							<li>When: Wednesday, 7:15-8:45pm (during private school term times)</li>
							<li>Where: CRCK, 17 Denison Street, Kingston (downstairs)</li>
							<li>Coordinator: Clancy Hartman</li>
							<li>
								Contact: <a href="mailto:office@kingstoncrc.org.au">office@kingstoncrc.org.au</a>
							</li>
						</ul>
					</p>
					<br />
					<p>
						Cadets Details:
						<ul>
							<li>When: Monday, 7:00-8:45pm (during private school term times)</li>
							<li>Where: CRCK building, 17 Denison Street, Kingston (downstairs)</li>
							<li>Coordinator: Reuben Verdouw</li>
							<li>
								Contact: <a href="mailto:office@kingstoncrc.org.au">office@kingstoncrc.org.au</a>
							</li>
						</ul>
						<img className="noFloatRightMobile" src={CadetsImg} style={{ float: "right" }} alt="" />
					</p>
				</section>
			</section>
		);
	}
}

export default YouthMinistry;
